import React from "react";

import "../../Styles/contact.css";

import { useEffect } from "react";

const ContactUs = () => {
  useEffect(() => {
    window.location.href = "https://calendly.com/teja-prosapiens/new-meeting";
  }, []);

  return (
    <div style={{ textAlign: "center", padding: "5rem 2rem", fontFamily: "sans-serif" }}>
      <h2>Redirecting to scheduler...</h2>
      <p>If you are not redirected automatically, please <a href="https://calendly.com/teja-prosapiens/new-meeting">click here</a>.</p>
    </div>
  );
};

export default ContactUs;
